import {NgModule} from '@angular/core';
import {SharedModule} from '@app/shared/shared.module';
import {NotificationIndicatorComponent} from './notification-indicator.component';
import {NotificationCountBadgeComponent} from './notification-count-badge.component';

@NgModule({
    declarations: [
        NotificationIndicatorComponent,
        NotificationCountBadgeComponent
    ],
    imports: [
        SharedModule
    ],
    exports: [
        NotificationIndicatorComponent,
        NotificationCountBadgeComponent
    ]
})
export class SharedNotificationIndicatorModule {
}
